<svelte:options tag="svelte-datagrid" />
<script>
	import { createEventDispatcher, onDestroy, onMount } from "svelte";
	import { get_current_component } from "svelte/internal";
	import Combo from "./Combo.svelte";
	import InputNumber from "./InputNumber.svelte";
	import SelectSvelte from "./SelectSvelte.svelte";
	import TextEditor from "./TextEditor.svelte";
	import Calendario from "./Calendario.svelte";
	import DatePicker from "./DatePicker.svelte";	
	import {clickOutside} from './clickOutside.js';

	export let absolute = true;
	export let columns = [];
	export let dataProvider = [];
	export let maxHeight = "";
	export let mensagemVazio = "Não existem registros";
	export let mostrarMensagemVazio = false;
	export let showHeader = true;
	export let smaller = false;
	export let grid = true;
	export let sortArray = true;

	const component = get_current_component();
	const svelteDispatch = createEventDispatcher();
	const dispatch = (name, detail) => {
		svelteDispatch(name, detail);
		component.dispatchEvent &&
			component.dispatchEvent(new CustomEvent(name, { detail }));
	};

	let checkboxRef;
	let jaDisparou = false;
	let lastDataProviderLength = 0;
	let lastScrollTop = 0;
	let registroSelecionado = {};
	let scrollContainer;
	let __idCounter = 0;

	onMount(async () => {});

	onDestroy(() => {});

	$: {
	    if (dataProvider) {
	      dataProvider.forEach((item) => {
	        if (!item._refresh) {
	          item._refresh = new Date().toISOString();
	        }
	      });
	    }
	}

	$: if (dataProvider && scrollContainer) {
		if (dataProvider.length < lastDataProviderLength) {
			lastScrollTop = 0;
			scrollContainer.scrollTop = 0;
		}

		lastDataProviderLength = dataProvider.length;
	}

	$: if (dataProvider && columns && checkboxRef) {
		const checkboxColumn = columns.find((column) => column.checkbox && column.selectAll);

		if (checkboxColumn && dataProvider.length > 0) {
			checkboxRef.checked = dataProvider.every((item) => item[checkboxColumn.dataField] === checkboxColumn.checkbox[0]);
		}
	}
	
	export function refresh() {
		if (columns) {
			for (let i = 0; i < columns.length; i++) {
				if (columns[i].checkbox && checkboxRef && checkboxRef.checked) {
					checkboxRef.checked = false;
				}
				columns[i]._refresh = new Date().toISOString();
			}
		}
		
		if (dataProvider) {
			for (let i = 0; i < dataProvider.length; i++) {
				if (!dataProvider[i].__id) {
					__idCounter++;
					dataProvider[i].__id = __idCounter;
				}
				dataProvider[i]._refresh = new Date().toISOString();
			}
		}
	}

	export function selecionarRegistro(registro) {
		let idx = dataProvider.indexOf(registro);
		clickRegistro(registro, idx);
	}

	function clickRegistro(registro, idx) {		
		if (!registro.__id) {
			__idCounter++;
			registro.__id = __idCounter;
		}
		registroSelecionado = registro;
		dispatch("onSelect", registroSelecionado);
	}

	function changeCheck(registro, coluna, event) {
		if (event.target.checked) {
			registro[coluna.dataField] = coluna.checkbox[0];
		} else {
			registro[coluna.dataField] = coluna.checkbox[1];
		}
		if (coluna.change) {
			coluna.change(registro, coluna, registro[coluna.dataField]);
		}
		if (coluna.click) {
			coluna.click(registro, coluna, registro[coluna.dataField]);
		}
		
		if (coluna.selectAll && checkboxRef) {
			checkboxRef.checked = dataProvider.every((item) => item[coluna.dataField] === coluna.checkbox[0]);
		}
	}

	function changeCheckAll(coluna, event) {
		for (let i = 0; i < dataProvider.length; i++) {
			if (event.target.checked) {
				dataProvider[i][coluna.dataField] = coluna.checkbox[0];
			} else {
				dataProvider[i][coluna.dataField] = coluna.checkbox[1];
			}
		}
		
		if (coluna.selectAllEvent) {
			coluna.selectAllEvent();
		}
		
		refresh();
	}

	function clickRenderer(registro, coluna, event) {
		event.stopPropagation();
		
		selecionarRegistro(registro);

		if (coluna.click) {
			coluna.click(registro, coluna, dataProvider);
		}
	}

	function duploClique(registro) {
		dispatch("doubleclick", registro);
	}

	function onScroll() {
		if (jaDisparou || !scrollContainer) return;

		const scrollTop = scrollContainer.scrollTop;

		if (scrollTop === lastScrollTop) return;
		lastScrollTop = scrollTop;

		const offsetHeight = scrollContainer.offsetHeight;
		const scrollHeight = scrollContainer.scrollHeight;
		
		const scrollBottomOffset = scrollHeight - scrollTop - offsetHeight;
		const scrollThresholdPx = 1;

		if (scrollBottomOffset > scrollThresholdPx) return;

		jaDisparou = true;
		dispatch("finalScroll", {});

		setTimeout(() => {
			jaDisparou = false;
			if (scrollTop !== scrollContainer.scrollTop) onScroll();
		}, 1000);
	}

	function validateNumber(e) {
		// let input = String.fromCharCode(e.charCode);
		// const reg = /^\d+$/;
		// if (!reg.test(input)) {
		// 	e.preventDefault();
		// }
	}

	async function onBlurChange(column, registro, casas) {
		if (registro[column.dataField]) {
			let n = Number(registro[column.dataField]);
			registro[column.dataField] = Number(Number(n).toFixed(casas));
		} else {
			registro[column.dataField] = 0;
		}
		refresh();
		if (column.valida) {
			const valido = await column.valida(registro, column, dataProvider);
			if (!valido) {
				// this.vars.showMessage(valido.mensagem);
				if ("rollback" in column) {
					column.rollback(registro, column);
				}
			} else {
				column.commit(registro, column);
			}
		}
	}

	function clickColuna(coluna) {
		if (coluna.dataField) {
			if (coluna.ordenado) {
				if (coluna.ordenado == "C") {
					coluna.ordenado = "D";
				} else {
					coluna.ordenado = "C";
				}
			} else {
				tirarOrdenacaoOutrasColunas(coluna);
				coluna.ordenado = "C";
			}
			columns = columns;
			if (sortArray) {
				aplicarOrdenacao(coluna);
			}
			dispatch("onSortColumn", coluna);
		}
	}

	function aplicarOrdenacao(coluna) {
		let sortAsDate = false;
		let sortAsDateTime = false;
		let sortModifier = coluna.ordenado == "C" ? 1 : -1;

		let sort = (a, b) => {
			if (a[coluna.dataField] &&
				b[coluna.dataField] &&
				a[coluna.dataField].toString().length == 10 &&
				a[coluna.dataField].toString().indexOf("/") == 2 &&
				a[coluna.dataField].toString().indexOf("/", 3) == 5) {
				sortAsDate = true;
			}

			if (a[coluna.dataField] &&
				b[coluna.dataField] &&
				a[coluna.dataField].toString().length == 19 &&
				a[coluna.dataField].toString().indexOf("/") == 2 &&
				a[coluna.dataField].toString().indexOf("/", 3) == 5 &&
				a[coluna.dataField].toString().indexOf(":") == 13) {
				sortAsDateTime = true;
			}

			if (sortAsDate) {
				let compA = new Date(
					Number(a[coluna.dataField].substr(6, 4)),
					Number(a[coluna.dataField].substr(3, 2)) - 1,
					Number(a[coluna.dataField].substr(0, 2))).getTime();
				let compB = new Date(
					Number(b[coluna.dataField].substr(6, 4)),
					Number(b[coluna.dataField].substr(3, 2)) - 1,
					Number(b[coluna.dataField].substr(0, 2))).getTime();

				return compA < compB
					? -1 * sortModifier
					: compA > compB
					? 1 * sortModifier
					: 0;
			} else if (sortAsDateTime) {
				let compA = new Date(
					Number(a[coluna.dataField].substr(6, 4)),
					Number(a[coluna.dataField].substr(3, 2)) - 1,
					Number(a[coluna.dataField].substr(0, 2)),
					Number(a[coluna.dataField].substr(11, 2)),
					Number(a[coluna.dataField].substr(14, 2)),
					Number(a[coluna.dataField].substr(17, 2)));
				let compB = new Date(
					Number(b[coluna.dataField].substr(6, 4)),
					Number(b[coluna.dataField].substr(3, 2)) - 1,
					Number(b[coluna.dataField].substr(0, 2)),
					Number(b[coluna.dataField].substr(11, 2)),
					Number(b[coluna.dataField].substr(14, 2)),
					Number(b[coluna.dataField].substr(17, 2)));

				return compA < compB
					? -1 * sortModifier
					: compA > compB
					? 1 * sortModifier
					: 0;
			} else {
				let compA = a[coluna.dataField] != null ? a[coluna.dataField].toString() : '';
				let compB = b[coluna.dataField] != null ? b[coluna.dataField].toString() : '';
				
				return compA.localeCompare(compB, undefined, { numeric: true, sensitivity: 'base' }) * sortModifier;
			}
		};

		dataProvider = dataProvider.sort(sort);
	}

	function tirarOrdenacaoOutrasColunas(colunaOrdenar) {
		for (let i = 0; i < columns.length; i++) {
			if (
				columns[i].dataField &&
				columns[i].dataField != colunaOrdenar.dataField
			) {
				columns[i].ordenado = null;
			}
		}
	}	

	function changeOption(column, registro, index) {
		registro[column.dataField] = column.options[index];
		refresh();
		// if (column.click) {
		// 	column.click(registro, column, this.dataProvider);
		// }
	}

	function clickEditarRegistro(registro, col) {
		if (!registro['edt_'+col.dataField]) {			
			registro['edt_'+col.dataField] = true;			
			refresh();
		}		
	}

	function sairEdicao(registro, col) {		
		registro['edt_'+col.dataField] = false;	
		if (col.change) {
			col.change(registro, col, registro[col.dataField]);
		}
		// refresh();	
	}

	function getLabelFromProvider(provider, labelField, keyField, valor) {		
		let ret = "";
		if(provider){		
			for (let i = 0; i < provider.length; i++) {
				if (provider[i][keyField] == valor) {
					ret = provider[i][labelField];
					break;
				}
			}
		}
		return ret;
	}
	

	async function loadDataProvider(col, registro) {
	  if (typeof col.customCombo === 'function') {
			if (!registro[col.dataProvider]) {
				registro[col.dataProvider] = await col.customCombo(registro);
				col.provider = registro[col.dataProvider];
    		}
		} else {
			col.provider = col.customCombo;
		}
	  return col.provider;
	}

</script>

{#if 1 == 2}
	<button class="truncate vgroup hgroup truncate2line hspacer cabecalhoMes diaFora diaHoje diaSelecionado diaSem calendario acao blink"><i /></button>
	<p class="btnMovMes" />
	<SelectSvelte />
	<TextEditor />
	<Calendario />
	<DatePicker />
{/if}

{#if columns && columns.length > 0}
	<div style="background-color: #fff;
		        border: { grid ? '1px solid #d3d3d3' : 'none' };
		        border-radius: { grid ? '3px' : '0' };
		        bottom: 0;
			    left: 0; 
			    margin: { smaller ? '0' : '3px' };
			    { maxHeight ? `max-height: ${maxHeight};` : '' }
			    overflow-y: auto;
			    position: { absolute ? 'absolute': 'relative' }; 
			    right: 0; 
			    top: 0;"
		bind:this={scrollContainer}
		on:scroll={onScroll}>
		<table style="width: 100%;">
			{#if showHeader}
				<thead>
					<tr>
						{#each columns as col, idxCol}
							{#if col.checkbox && col.selectAll}
								<th
									class="cabecalho truncate"
									class:no-grid={!grid}
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: col.label}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'left'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; border-left: {grid && idxCol > 0
										? '1px solid #d3d3d3'
										: 'none'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
								>
									<div class="hgroup" style="align-items: center; gap: 3px;">
										<input
											id={col.idPrefix ? col.idPrefix + 'SelectAll' : 'checkbox' + 'SelectAll'}
											type="checkbox" bind:this={checkboxRef}
											on:change={(e) => changeCheckAll(col, e)}/>
										<label for={col.idPrefix ? col.idPrefix + 'SelectAll' : 'checkbox' + 'SelectAll'}>
											{col.label}
										</label>
									</div>
								</th>
							{:else if col.hideHeader}
								<div style="display: none"></div>
							{:else}
								<th
									class="cabecalho truncate"
									class:no-grid={!grid}
									on:click={() => clickColuna(col)}
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: col.label}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'left'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; border-left: {grid && idxCol > 0
										? '1px solid #d3d3d3'
										: 'none'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
								>
									<div
										class="hgroup"
										style="align-items: center; justify-content: {col.textAlign
											? col.textAlign
											: 'left'};"
									>
										<div class="truncate">{col.label}</div>
										{#if col.ordenado && col.ordenado == "C"}
											<i
												class="fas fa-angle-down"
												style="margin-left: 10px;"
											/>
										{/if}
										{#if col.ordenado && col.ordenado == "D"}
											<i
												class="fas fa-angle-up"
												style="margin-left: 10px;"
											/>
										{/if}
									</div>
								</th>
							{/if}
						{/each}
					</tr>
				</thead>
			{/if}
			<tbody>
				{#each dataProvider ? dataProvider : [] as registro, idxReg}
					<tr
						on:click={() => clickRegistro(registro, idxReg)}
						on:dblclick={() => duploClique(registro)}
						class:selecionado={registroSelecionado.__id
							? registro.__id == registroSelecionado.__id
							: 1 == 2}
					>
						{#each columns as col, idx}
							{#if col.currency}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'right'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
								>
									{registro[col.dataField] != null
										? new Intl.NumberFormat("pt-BR", {
												minimumFractionDigits:
													col.decimais
														? col.decimais
														: 2,
										  }).format(registro[col.dataField])
										: ""}
								</td>
							{:else if col.currencyEditable}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'right'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};
										background-color: #FFF9C2;"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
									on:click={() => clickEditarRegistro(registro, col)}	
								>

									{#if registro['edt_'+col.dataField]}
										<InputNumber
											bind:objectSource={registro}
											editField={col.dataField}
											bind:changeFunction={col.change}
											decimals={2}
											on:blur={() => sairEdicao(registro, col)}
										/>
									{:else}
										{registro[col.dataField] != null
											? new Intl.NumberFormat("pt-BR", {
													minimumFractionDigits:
														col.decimais
															? col.decimais
															: 2,
											}).format(registro[col.dataField])
											: ""}
									{/if}
								</td>
							{:else if col.decimalEditable}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'right'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};
										background-color: #FFF9C2;"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
									on:click={() => clickEditarRegistro(registro, col)}
								>
									{#if registro['edt_'+col.dataField]}
										<InputNumber
											bind:objectSource={registro}
											bind:changeFunction={col.change}
											editField={col.dataField}
											decimals={3}
											on:blur={() => sairEdicao(registro, col)}
										/>
									{:else}
										{registro[col.dataField] != null
											? new Intl.NumberFormat("pt-BR", {
													minimumFractionDigits:
														col.decimais
															? col.decimais
															: 3,
											}).format(registro[col.dataField])
											: ""}
									{/if}
								</td>
							{:else if col.intEditable}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'right'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
								>
									<input
										type="number"
										bind:value={registro[col.dataField]}
										min="0"
										step="1"
										on:keypress={validateNumber}
										on:blur={() =>
											onBlurChange(col, registro)}
										style="border-width: 0px; width: 80px; padding-right: 10px;"
									/>
								</td>
							{:else if col.textEditable}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'right'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
								>
									<input
										type="text"
										bind:value={registro[col.dataField]}
										maxlength={col.maxLength ? col.maxLength : 100}
										disabled={col.disabled ? col.disabled(registro) : false}
										on:blur={() => col.change ? col.change(registro) : null}
										style="width: -webkit-fill-available; padding: 5px; border: 1px solid #d3d3d3; border-radius: 5px;"
									/>
								</td>
							{:else if col.dateEditable}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'right'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};
										background-color: #FFF9C2;"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}	
									on:click={() => clickEditarRegistro(registro, col)}								
								>	
									{#if registro['edt_'+col.dataField]}
										<DatePicker
											bind:objectSource={registro}
											editField={col.dataField}										
											on:change={(e) => sairEdicao(registro, col)}
										/>
									{:else}
										{registro[col.dataField]}
									{/if}																									
								</td>
							{:else if col.options}
								<td
									class:no-grid={!grid}
									style="border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
								>
									<div class="hgroup" style="align-items: center; justify-content: center;">
										{#each col.options as opt, i}
											<div class="box" class:box-selected="{registro[col.dataField] == opt}"
												on:click={e => changeOption(col, registro, i)}>
												{ col.labels[i] ? col.labels[i] : opt }
											</div>
										{/each}
									</div>
								</td>
							{:else if col.customCombo}
								<td
									class:no-grid={!grid}
									style="border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};
										background-color: #FFF9C2;
										text-align: left;"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
									on:click={() => clickEditarRegistro(registro, col)}
								>
								{#if registro['edt_' + col.dataField]}
									<div style="width: inherit; max-width: {col.width ? col.width : 'auto'};" use:clickOutside on:click_outside={() => sairEdicao(registro, col)}>
									{#if typeof col.customCombo === 'function'}
										{#if !registro[col.dataProvider]}
											{#await loadDataProvider(col, registro, 'here') then providerData}
												<Combo
													dataProvider={providerData}
													bind:objectSource={registro}
													labelField={col.labelField}
													keyField={col.keyField}
													editField={col.dataField}
													on:change={(e) => sairEdicao(registro, col)}
													disabled={col.disabled ? col.disabled(registro) : false}
													naoExibirNenhum={col.naoExibirNenhum}
												/>
											{/await}
										{:else}
											<Combo
												dataProvider={registro[col.dataProvider]}
												bind:objectSource={registro}
												labelField={col.labelField}
												keyField={col.keyField}
												editField={col.dataField}
												on:change={(e) => sairEdicao(registro, col)}
												disabled={col.disabled ? col.disabled(registro) : false}
												naoExibirNenhum={col.naoExibirNenhum}
											/>
										{/if}
									{:else}
										<Combo
											dataProvider={col.customCombo}
											bind:objectSource={registro}
											labelField={col.labelField}
											keyField={col.keyField}
											editField={col.dataField}
											on:change={(e) => sairEdicao(registro, col)}
											disabled={col.disabled ? col.disabled(registro) : false}
											naoExibirNenhum={col.naoExibirNenhum}
										/>
									{/if}
									</div>
								{:else}
									{#if typeof col.customCombo === 'function'}
										{#if !registro[col.dataProvider]}
											{#await loadDataProvider(col, registro, 'there') then providerData}
												{getLabelFromProvider(providerData, col.labelField, col.keyField, registro[col.dataField], 'bla')}
											{/await}
										{:else}
											{getLabelFromProvider(registro[col.dataProvider], col.labelField, col.keyField, registro[col.dataField], 'bli')}
										{/if}
									{:else}
										{getLabelFromProvider(col.customCombo, col.labelField, col.keyField, registro[col.dataField], 'ble')}
									{/if}
								{/if}								
								</td>
							{:else if col.renderer && col.tooltipTextFunction}
								<td
									class:no-grid={!grid}
									id={col.idPrefix && registro[col.idField] ? col.idPrefix + registro[col.idField] : null}
									style="border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipTextFunction
										? col.tooltipTextFunction(registro, col)
										: registro[col.dataField]}
									on:click={(e) =>
										clickRenderer(registro, col, e)}
								>
									<div
										class="vgroup"
										style="cursor: pointer; align-items: {col.textAlign
											? col.textAlign
											: 'center'}; justify-content: {col.textAlign
											? col.textAlign
											: 'center'};"
									>
										{@html col.renderer(registro, col)}
									</div>
								</td>
							{:else if col.renderer}
								<td
									class:no-grid={!grid}
									id={col.idPrefix && registro[col.idField] ? col.idPrefix + registro[col.idField] : null}
									style="border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
									on:click={(e) =>
										clickRenderer(registro, col, e)}
								>
									<div
										class="vgroup"
										style="cursor: pointer; align-items: {col.textAlign
											? col.textAlign
											: 'center'}; justify-content: {col.textAlign
											? col.textAlign
											: 'center'};"
									>
										{@html col.renderer(registro, col)}
									</div>
								</td>
							{:else if col.checkbox}
								<td
									class:no-grid={!grid}
									style="text-align: center; border-Left: {grid && idx >
									0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
								>
								{#key registro._refresh}
									<input
										id={col.idPrefix && registro[col.idField] ? col.idPrefix + registro[col.idField] : null}
										type="checkbox"
										checked={registro[col.dataField] ==
											col.checkbox[0]}
										disabled={col.disabled
											? col.disabled(registro)
											: false}
										on:change={(e) =>
											changeCheck(registro, col, e)}
									/>
								{/key}
								</td>
							{:else if col.tooltipTextFunction}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'left'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									class="truncate"
									data-toogle="tooltip"
									title={col.tooltipTextFunction
										? col.tooltipTextFunction(registro, col)
										: registro[col.dataField]}
								>
									{registro[col.dataField]
										? registro[col.dataField]
										: ""}
								</td>
							{:else}
								<td
									class:no-grid={!grid}
									style="text-align: {col.textAlign
										? col.textAlign
										: 'left'}; border-left: {grid && idx > 0
										? '1px solid #d3d3d3'
										: 'none'}; width: {col.width
										? col.width
										: 'auto'}; max-width: {col.width
										? col.width
										: 'auto'}; min-width: {col.width
										? col.width
										: 'auto'}; white-space: {col.breakWord
										? 'unset'
										: 'no-wrap'}; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
									class="truncate"
									data-toogle="tooltip"
									title={col.tooltipText
										? col.tooltipText
										: registro[col.dataField]}
								>
									{registro[col.dataField] != null
										? registro[col.dataField]
										: ""}
								</td>
							{/if}
						{/each}
					</tr>
				{:else}
					{#if mostrarMensagemVazio}
						<tr>
							<td colspan={columns.length}>
								<div
									style="padding: 10px; background-color: #f0f0f0; color: #646464; font-size: medium; text-align: center; font-size: {smaller ? 'x-small' : 'normal'}; padding: {smaller ? '4px' : '8px'};"
								>
									{mensagemVazio}
								</div>
							</td>
						</tr>
					{/if}
				{/each}
				<!-- {#if mostrarMensagemVazio && (!dataProvider || dataProvider.length == 0)}
					<tr>
						<td style="colspan={columns.length}">
							<div style="padding: 10px; background-color: #f0f0f0; color: #646464; font-size: medium; text-align: center;">
								{mensagemVazio}
							</div>
						</td>
					</tr>
				{/if} -->
			</tbody>
		</table>
	</div>
{/if}

<style>
	@import "./assets/fontawesome/css/all.css";
	/* @import "/assets/bootstrap/css/bootstrap.min.css"; */

	table {
		border-spacing: 0;
	}
	tr {
		cursor: pointer;
	}

	tr:hover {
		background-color: #f0f0f0;
		color: #000;
	}
	th {
		padding: 8px;
		border: none;
		border-bottom: 1px solid #d3d3d3;
		color: #333;
		position: sticky;
		top: 0;
		background-color: rgb(233, 233, 233);
		z-index: 100000000;
	}

	th:hover {
		background-color: #f0f0f0;
	}

	th.no-grid {
		background-color: transparent;
		border-bottom: none;
		color: black;
	}

	td {
		padding: 8px;
		border: none;
		border-bottom: 1px solid #f0f0f0;
	}

	td.no-grid {
		border-bottom: none;
	}	

	.selecionado {
		background-color: rgb(123, 174, 255);
	}

	.selecionado:hover {
		background-color: rgb(123, 174, 255);
	}

	.hgroup {
		display: flex;
		flex-direction: row;
	}

	.vgroup {
		display: flex;
		flex-direction: column;
	}

	.truncate {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.truncate2line {
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	button {
		background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
		background-color: rgba(0, 0, 0, 0);
		border: none;
		padding: 0;
		flex: 1;
		height: 100%;
		outline: none;
		font-size: 12px;
		cursor: pointer;
	}

	i {
		text-align: center;
	}

	p {
		margin: 0;
	}

	div {
		text-align: center;
	}

	.hspacer {
		flex: 1;
	}
	/* .cabecalho {
		background-color: #f0f0f0;
	} */
	.cabecalhoMes {
		background-color: #d3d3d3;
		padding: 5px 0;
		justify-content: center;
		width: 100%;
		font-weight: bold;
		align-items: center;
		font-size: small;
	}
	.calendario {
		position: relative;
		top: 0px;
		left: 0px;
		border: 1px solid #d3d3d3;
		border-radius: 3px;
		background-color: #fff;
	}
	.diaSem {
		width: 35px;
		text-align: center;
		padding: 5px 0;
		margin: 5px;
		cursor: pointer;
		font-size: small;
	}
	.diaFora {
		width: 35px;
		text-align: center;
		padding: 5px 0;
		margin: 5px;
		cursor: pointer;
		color: #d3d3d3;
		font-size: small;
	}
	.diaHoje {
		width: 35px;
		text-align: center;
		padding: 5px 0;
		margin: 5px;
		cursor: pointer;
		color: royalblue;
		border: 1px solid royalblue;
		font-size: small;
	}
	.diaSelecionado {
		width: 35px;
		text-align: center;
		padding: 5px 0;
		margin: 5px;
		cursor: pointer;
		color: #fff;
		background-color: royalblue;
		font-size: small;
	}
	.btnMovMes {
		background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
		background-color: rgba(0, 0, 0, 0);
		border: none;
		outline: none;
	}
	.acao {
		font-weight: bold;
		font-size: x-small;
		background-color: red;
		padding: 3px 8px;
		border-radius: 3px;
		color: white;
		margin-right: 3px;
	}

	.blink {
		animation: blinker 1s linear infinite;
	}

	.box {
		height: 20px;
		background-color: #d3d3d3;
		border-radius: 3px;
		margin: 2px;
		padding: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		min-width: 20px;
	}

	.box-selected {
		background-color: darkslateblue;
		color: white;
	}

	::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	::-webkit-scrollbar-thumb {
		background: #d3d3d3;
	}

	/* ::-webkit-scrollbar-button:single-button {
		background-color: #f1f1f1;
		display: block;
		border-style: solid;
		height: 10px;
		width: 10px;
	} */

	@keyframes blinker {
		50% {
			opacity: 0;
		}
	}

</style>
